// @ts-nocheck
import React from 'react';
import DOMPurify from 'dompurify';

const ALLOWED_TAGS = ['b', 'p', 'h1', 'h2'];

const sanitizeHTML = (html) => {
  const sanitized = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ALLOWED_TAGS,
  });
  return sanitized;
};

const HTMLRenderer = ({ html }) => (
  <div dangerouslySetInnerHTML={{ __html: sanitizeHTML(html) }} />
);

export default HTMLRenderer;